module.exports = __webpack_public_path__ + "img/logo-header.4d47e749.png";